import React, { Component }  from 'react';
import moment from 'moment';

class Countdown extends Component {
  state = {
    currentTime: moment(),
  }

  componentDidMount() {
    if (this.props.from) {
      this.setState({
        currentTime: this.props.from,
      });
    }
  }

  getHumanDiff() {
    const toDate = this.state.currentTime;
    const fromDate = this.props.to;
    const days = fromDate.diff(toDate, 'days');
    const hours = fromDate.diff(toDate, 'hours');
    const minutes = fromDate.diff(toDate, 'minutes');

    if (days > 1) {
      return `${days} days`;
    } else if (hours > 1) {
      return `${hours} hours`;
    } else {
      return `${minutes} minutes`;
    }
  }

  render() {
    const diff = this.getHumanDiff();

    return (<h2 className="title is-2">Leaving in {diff}</h2>);
  }
}

export default Countdown;



// WEBPACK FOOTER //
// ./src/components/countdown.js